import React, { useMemo } from 'react';

import { useSelector } from 'umi';
import LeadDropdownFilter from '@/components/Filters/LeadDropdownFilter';
import { F } from '@/utils/intl';
import * as JourneySelectors from '@/selectors/journeySelectors';
import { useHasMarketingDataAccess } from '@/utils/hooks';

const LeadSourceDropdownFilters = ({ onSelectionChange, hideIfSingle, leadSourceType, ...props }: any) => {
  // Lead sources are the current journeys
  const leadSources = useSelector(JourneySelectors.selectJourneys);
  const hasMarketingDataAccess = useHasMarketingDataAccess();

  const filteredLeadSources = useMemo(() => leadSourceType ? leadSources.filter(source => source.type === leadSourceType) : leadSources, [leadSources, leadSourceType]);

  const handleSelectionChange = (selectedValues) => {
    if (onSelectionChange)
      onSelectionChange(selectedValues);
  };

  if (!hasMarketingDataAccess) return null;
  if (hideIfSingle && filteredLeadSources?.length <= 1) return null;

  return (
    <LeadDropdownFilter
      placeholder={
        <F
          id={'pages.leads.filters.leadSource.placeholder'}
          defaultMessage={'Source'}
        />
      }
      filterKey={'lead_source'}
      type={props?.type ? props.type : 'tree'}
      treeData={filteredLeadSources?.map((source) => ({
        title: source.name,
        value: source.hashId,
        key: source.hashId,
      }))}
      options={filteredLeadSources}
      onChange={handleSelectionChange}
      selectProps={{
        style: {
          minWidth: 200,
        },
      }}
      {...props}
    />
  );
};

export default LeadSourceDropdownFilters;
